import ArrowShrink from './src/arrow-shrink-combined';
export default ArrowShrink;